import { createContext, ReactNode, useState } from 'react'
import _ from 'lodash'
import { TtypesContext } from '@/types/typesContext'

const initialValue: TtypesContext = {
  data: {},
  setData: () => {}
}

export const typesContext = createContext<TtypesContext>(initialValue)

export function TypesProvider({ children }: { children: ReactNode }) {
  const [data, setData] = useState({})

  return (
    <typesContext.Provider
      value={{
        data,
        setData
      }}
    >
      {children}
    </typesContext.Provider>
  )
}
